document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.hp-grid__add-btn[data-variant-id]');

  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      if (button.disabled || button.classList.contains('is-loading')) return;

      const variantId = button.dataset.variantId;
      if (!variantId) return;

      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      button.classList.add('is-loading');

      const body = {
        id: variantId,
        quantity: 1,
      };

      if (cart) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        if (cart.setActiveElement) cart.setActiveElement(button);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            console.error(response.description || response.message);
            return;
          }

          if (cart && cart.renderContents) {
            cart.renderContents(response);
          } else {
            window.location = window.routes ? window.routes.cart_url : '/cart';
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          button.classList.remove('is-loading');
        });
    });
  });
});
